import { memo, useEffect, useState } from 'react';
import classNames from 'classnames/bind';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretUp } from '@fortawesome/pro-solid-svg-icons/faCaretUp';
import { faCaretDown } from '@fortawesome/pro-solid-svg-icons/faCaretDown';
import { faChevronDown } from '@fortawesome/pro-light-svg-icons/faChevronDown';

import CFLink from '../CFLink';

import Styles from './styles.module.scss';

const cx = classNames.bind(Styles);

const DataTableCollapsable = ({
  columns,
  data,
  onSort,
  className = '',
  rowClassName = '',
}) => {
  const [collapsed, setCollapsed] = useState(() => (
    Array(data.length).fill(false)
  ));

  useEffect(() => {
    setCollapsed(Array(data.length).fill(false));
  }, [data]);

  const collapseRow = (indexToCollapse) => {
    setCollapsed((current) => (
      current.map((value, index) => (
        index === indexToCollapse ? !value : value
      ))
    ));
  };

  return (
    <div className={cx('data-table-collapsable', className)}>
      <div className={cx('table-row-wrapper', rowClassName)}>
        <div className={cx('table-row')}>
          {columns.map((column) => (
            <div
              key={column.key}
              className={cx('table-header', { sortable: column.sort, 'right-aligned': column.rightAligned, 'force-left-aligned': column.forceLeftAligned })}
              onClick={column.sort ? () => onSort(column.key) : undefined}
            >
              <div className={cx('table-data-wrapper')}>
                {column.title}
              </div>
              {column.sort && (
                <div className={cx('arrows')}>
                  <FontAwesomeIcon icon={faCaretUp} className={cx('asc')} />
                  <FontAwesomeIcon icon={faCaretDown} className={cx('desc')} />
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
      {data.map((row, rowIndex) => (
        <div
          key={row.uid}
          className={cx('table-row-wrapper', rowClassName)}
        >
          <div
            className={cx('table-row', {
              collapsed: collapsed[rowIndex],
              clickable: row.collapseContent !== undefined,
            })}
            onClick={row.collapseContent !== undefined ? () => collapseRow(rowIndex) : undefined}
          >
            {columns.map((column, columnIndex) => (
              <div key={column.key} className={cx('table-data')}>
                <div className={cx('table-data-wrapper', { 'right-aligned': column.rightAligned, 'force-left-aligned': column.forceLeftAligned })}>
                  {row.mainData?.[column.key] && row.mainData[column.key] instanceof Object && ('url' in row.mainData[column.key]) ? (
                    <CFLink
                      to={row.mainData[column.key].url}
                      external={!!row.mainData[column.key].url?.startsWith('http')}
                    >
                      {row.mainData[column.key].value}
                    </CFLink>
                  ) : (
                    row.mainData?.[column.key]
                  )}
                  {columnIndex === columns.length - 1 && row.collapseContent !== undefined && (
                    <FontAwesomeIcon
                      icon={faChevronDown}
                      className={cx('collapse-icon', { collapsed: collapsed[rowIndex] })}
                    />
                  )}
                </div>
              </div>
            ))}
          </div>
          {collapsed[rowIndex] && row.collapseContent !== undefined && (
            <div className={cx('collapse-content')}>
              {row.collapseContent}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

DataTableCollapsable.defaultProps = {
  columns: [],
  data: [],
  onSort() {},
};

export default memo(DataTableCollapsable);
